import { render, staticRenderFns } from "./TTI-Submod.vue?vue&type=template&id=5dfae08a&"
import script from "./TTI-Submod.vue?vue&type=script&lang=js&"
export * from "./TTI-Submod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports